import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Manager } from '@/types/club.model';
import { UserMinus } from 'lucide-react';
import React from 'react';

interface ConfirmRemoveManagerDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  manager: Manager | null;
  onConfirm: () => void;
  isLoading?: boolean;
}

const ConfirmRemoveManagerDialog: React.FC<ConfirmRemoveManagerDialogProps> = ({
  open,
  onOpenChange,
  manager,
  onConfirm,
  isLoading = false,
}) => {
  if (!manager) return null;

  const handleConfirm = () => {
    onConfirm();
    onOpenChange(false);
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <UserMinus size={20} className="text-red-600" />
            Eliminar Manager
          </AlertDialogTitle>
          <AlertDialogDescription className="text-left">
            ¿Estás seguro de que deseas eliminar a{' '}
            <span className="font-semibold">
              {manager.name || manager.username}
            </span>{' '}
            ({manager.email}) de la gestión del club?
            <br />
            <br />
            <span className="text-amber-700">
              Esta acción no se puede deshacer y el usuario perderá todos los
              permisos para gestionar torneos en este club.
            </span>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoading}>Cancelar</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            className="bg-red-600 hover:bg-red-700"
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <div className="mr-2 h-3 w-3 animate-spin rounded-full border-b-2 border-white"></div>
                Eliminando...
              </>
            ) : (
              'Eliminar Manager'
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ConfirmRemoveManagerDialog;
